import MainLayout from "./MainLayout";

export default MainLayout;

export * from "./MainLayout";
